import { X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const BaseToastContainer = styled.div<{ visible?: boolean }>`
  position: fixed;
  z-index: 1000;
  color: white;
  flex-direction: row;
  padding: 10px;
  width: 50%;
  left: 30%;
  display: flex;
  top: ${(props) => (props.visible ? 10 : -300)}px;
  cursor: pointer;
  border-radius: 8px;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition:
    opacity,
    top 0.5s;
  background: rgba(0, 111, 60, 0.8);
  @media (max-width: 1024px) {
    width: 100%;
    left: 0;
    top: ${(props) => (props.visible ? 0 : -300)}px;
    border-radius: 0;
  }
`

interface ScheduleOrderToastProps {
  visible: boolean
  message: string
  onClickMessage: () => void
  onClose: () => void
}

// Toast thông báo có đơn hẹn giờ mới, bấm vào để sang danh sách đơn
const ScheduleOrderToast = ({ visible, message, onClickMessage, onClose }: ScheduleOrderToastProps) => {
  return (
    <BaseToastContainer visible={visible}>
      <div onClick={onClickMessage} style={{ flex: 1 }}>
        {message}
      </div>
      <X onClick={onClose} style={{ color: 'white', marginRight: 15 }} />
    </BaseToastContainer>
  )
}

export default ScheduleOrderToast
